import YearOfCalm from '@/components/gift/YearOfCalm';
import Header from '@/components/header/Header';

import { Wrapper } from './styles';

const GiftLayout = () => (
	<>
		<Header isStatic />
		<Wrapper>
			<YearOfCalm />
		</Wrapper>
	</>
);

export default GiftLayout;
